<div class="product-box">
	<div class="product-info">
		<div class="name" (click)="showAdditionalData = !showAdditionalData">
			{{ product.name }}
		</div>
		<div class="address">Wykorzystano {{ product.occupancy }}</div>
		<div class="additionalData" *ngIf="showAdditionalData">
			<div class="address">
				{{ product.address }} {{ product.buildingNumber }}<br />
				{{ product.zipCode }}
			</div>
			<small class="conveniences">Udogodnienia</small>
			<ul class="conveniences">
				<li *ngFor="let convenient of product.conveniences">
					{{ convenient.name }}
				</li>
			</ul>
		</div>
		<div class="btn btn-link" (click)="availabilitySet()"><i class="fas fa-edit"></i> Dostępność</div>
	</div>
	<div class="product-data">
		<div *ngFor="let room of product.rooms" [id]="'room' + room.id">
			<app-accommodation-list-product-room [room]="room"></app-accommodation-list-product-room>
			<div *ngIf="show?.subrooms">
				<div *ngFor="let subRoom of room.roomSlaves" style="height: 40px">
					{{ subRoom.roomType.code }}
				</div>
			</div>
		</div>
	</div>
</div>
